import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InterventionComponent } from './components/intervention/intervention.component';
import { MyCalendarComponent } from './components/my-calendar/my-calendar.component';
import { RedirectComponent } from './components/redirect/redirect.component';
import { ErrorComponent } from './error.component';
import { ENavigationRoute } from './model/enum/navigation-route';
import { LoginGuard } from './tools/login-guard';
import { UserConfigurationComponent } from './components/user-configuration/user-configuration.component';
import { DrawingMapToolComponent } from './components/drawing-map-tool/drawing-map-tool.component';

const routes: Routes = [
    { path: '', pathMatch: 'full', redirectTo: ENavigationRoute.Home },
    { path: ENavigationRoute.Home, component: MyCalendarComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Intervention, component: InterventionComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.UserConfiguration, component: UserConfigurationComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.DrawingTool, component: DrawingMapToolComponent, canActivate: [LoginGuard] },
    { path: ENavigationRoute.Error, component: ErrorComponent },
    { path: 'redirect', component: RedirectComponent },
    { path: '**', component: ErrorComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
